<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" :ref="searchForm" center size="medium">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable>
              <el-option v-for="item in tcList" :key="item.value" :label="item.AB_NAME" :value="item.TC_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable>
              <el-option v-for="item in projectList" :key="item.value" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
              :clearable="false"></el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">筛选</el-button>
          <download-excel style="display: inline;" :data="exportData" :fields="exportFields"
            :name="`项目销售日汇总表-${searchForm.DAY_INTERVAL[0]}~${searchForm.DAY_INTERVAL[1]}.xls`" :before-finish="endDownload"
            :before-generate="exportExcel">
            <el-button size="medium" type="primary" v-preventReClick plain>
              导出
            </el-button>
          </download-excel>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin:15px 0">
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="SEND_DAY" label="日期"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="PURCHASE_FEE" label="采购金额（含税）"></el-table-column>
          <el-table-column prop="PURCHASE_FEE_EXCLUDING_TAX" label="采购金额（不含税）"></el-table-column>
          <el-table-column prop="SALES_FEE" label="销售金额（含税）"></el-table-column>
          <el-table-column prop="SALES_FEE_EXCLUDING_TAX" label="销售金额（不含税）"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height: 100px">
      <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right; height: 100px">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import date from '@/assets/common/date';
import http from '@/assets/common/http';

let GYS_ID;
export default {
  data() {
    return {
      tcList: JSON.parse(sessionStorage.getItem('allCustomerList')),
      projectList: JSON.parse(sessionStorage.getItem('usingProjectList')),
      searchForm: {
        DAY_INTERVAL: ['', ''].fill(date(new Date(), '%F')),
      },
      tableData: [],
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      totalCount: 0,
      exportData: [],
      exportFields: {
        日期: 'SEND_DAY',
        项目点: 'PROJECT_NAME',
        产品编码: 'PRODUCT_CODE',
        产品名称: 'PRODUCT_NAME',
        实收数量: 'REAL_COUNT',
        '采购金额（含税）': 'PURCHASE_FEE',
        '采购金额（不含税）': 'PURCHASE_FEE_EXCLUDING_TAX',
        '销售金额（含税）': 'SALES_FEE',
        '销售金额（不含税）': 'SALES_FEE_EXCLUDING_TAX',
      },
    };
  },
  created() {
    GYS_ID = sessionStorage.getItem('tcId');
    if (this.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION.CONDITION) {
      this.searchForm = this.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION.CONDITION;
      this.totalCount = this.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION.TOTAL_COUNT;
      this.currentPage = this.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION.CURRENT_PAGE;
    }
    this.queryData();
  },
  computed: {
    PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION() {
      return this.$store.state.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION;
    },
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 95,
        GYS_ID,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      for (const key in this.searchForm) {
        if (key == 'DAY_INTERVAL' && this.searchForm[key].length) {
          [params.START_DATE, params.END_DATE] = this.searchForm[key];
        } else if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      http.post(params).then((res) => {
        this.tableData = res[0].LIST;
        this.totalCount = res[0].TOTAL_COUNT;
        this.$store.dispatch('SET_PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION', {
          CONDITION: this.searchForm,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    async exportExcel() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 96,
        GYS_ID,
      };
      for (const key in this.searchForm) {
        if (key == 'DAY_INTERVAL' && this.searchForm[key].length) {
          [params.START_DATE, params.END_DATE] = this.searchForm[key];
        } else if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      await http.post(params).then((res) => {
        this.exportData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    endDownload() {
      this.exportData = [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/projectSalesDailySummary.vue